export const CELL_WIDTH = 38.33;
export const LABEL_BOX_WIDTH = 20.0;
export const LABEL_MARGIN = (CELL_WIDTH - LABEL_BOX_WIDTH) / 2;
export const GAPS = {
  top: 7,
  right: 19,
  bottom: 5,
  left: 19,
};
